
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"29","fill":"#2F6BF0","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.567 24.469a3.972 3.972 0 01-2.854-1.178 3.972 3.972 0 01-1.179-2.855c0-1.087.408-2.084 1.179-2.855L16.222 6.072c2.084-2.084 5.528-2.084 7.612 0a5.383 5.383 0 011.586 3.806c0 1.45-.543 2.764-1.586 3.807l-8.609 8.609-.906-.906 8.61-8.61c1.585-1.586 1.585-4.214 0-5.8-1.587-1.586-4.215-1.586-5.8 0l-11.51 11.51c-.544.498-.816 1.223-.816 1.948 0 .725.272 1.45.816 1.949a2.735 2.735 0 003.897 0l8.609-8.61a1.422 1.422 0 000-1.994 1.422 1.422 0 00-1.994 0l-5.754 5.755-.907-.906 5.755-5.755a2.653 2.653 0 013.761 0 2.653 2.653 0 010 3.761l-8.61 8.61c-.724.815-1.721 1.223-2.809 1.223z"}})])
          )
        }
      }
    